import React, { useState } from 'react'
import axios from 'axios'; import { Avatar } from '@material-ui/core'
import Rating from '@mui/material/Rating';
import { Dropdown } from 'react-bootstrap';
import { DeleteForever, Edit, MoreVert } from '@material-ui/icons';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from 'react-redux';

const ReviewItem = ({ internship, reload }) => {
  const dispatch = useDispatch()
  const [update, setUpdate] = React.useState(false);


  const [arrangement, setArrangement] = useState(internship.arrangement);
  const [rating, setRating] = useState(internship.rating);
  const [review, setReview] = useState(internship.review);
  const [email, setEmail] = useState(internship.email);
  const [name, setName] = useState(internship.name);
  const [profilePic, setProfilePic] = useState(internship.profile_pic);
  const [courseId, setCourseId] = useState(internship.course_id);
  const [status, setStatus] = useState(internship.status);

  const handleClose = () => {
    setArrangement("")
    setRating("")
    setReview("")
    setEmail("")
    setName("")
    setProfilePic("")
    setCourseId("")
    setStatus("")
    setUpdate(false)
  };
  const [open, setOpen] = useState({
    open: false,
    message: '',
    type: ''

  });
  const updateReview = async (e) => {
    dispatch({type:'LOADING'})
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", internship.id);
    formData.append("arrangement", arrangement);
    formData.append("rating", rating);
    formData.append("review", review);
    formData.append("email", email);
    formData.append("name", name);
    if (profilePic && typeof profilePic !== "string") {
      formData.append("profile_pic", profilePic);
    }
    formData.append("course_id", courseId);
    formData.append("status", status);

    try {

      const response = await axios.post(`${ENDPOINT}update-review.php`, formData, SecurityHeaders);
      if (response.data.status === "success") {
        dispatch({type:'DONE_LOADING'})
        setUpdate(false);
        setOpen({ open: true, message: 'Review updated successfully!', type: 'success' });
        setArrangement("")
        setRating("")
        setReview("")
        setEmail("")
        setName("")
        setProfilePic("")
        setCourseId("")
        setStatus("")

        reload();

      }
      else {
        dispatch({type:'ERROR',payload:response.data.message})
      }
    } catch (error) {
     dispatch({type:'ERROR',payload:error.message})

    }
  };

  const deleteReview = async (id) => {
    dispatch({type:'LOADING'})
    try {
      const formData = new FormData();
      formData.append('id', id);
      const response = await axios.post(`${ENDPOINT}delete-review.php`, formData, SecurityHeaders);
      if (response.data.status === "success") {
        dispatch({type:'DONE_LOADING'})
        setOpen({ open: true, message: 'Review deleted successfully!', type:'success' });
        setUpdate(false);
        reload();
      } else {
        dispatch({type:'ERROR',payload:response.data.message})
        setUpdate(false);
    

      }
    } catch (error) {
 dispatch({type:'ERROR',payload:error.message})
    }
  }
  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(open => ({ ...open, open: false }));
  };
  return (
    <>

      <Snackbar open={open.open} onClose={handleClose2} autoHideDuration={4000} >
        <Alert

          severity={open.type === 'success' ? 'success' : 'error'}
          onClose={() => { }}
          variant="filled"
          className='col-md-6 col-12'

        >
          {open.message}
        </Alert>
      </Snackbar>

      <Modal show={update} onHide={handleClose}>
        <Modal.Body>
          <div>
            <h2>Update Review</h2>

            <form onSubmit={updateReview}>

              <div className="mb-3">
                <label htmlFor="arguments" className="form-label">Arguments</label>
                <input type="text" className='form-control' placeholder="Arrangement" value={arrangement} onChange={(e) => setArrangement(e.target.value)} />

              </div>

              <div className="mb-3">
                <label htmlFor="Review" className="form-label">Review</label>
                <textarea placeholder="Review" className='form-control' value={review} onChange={(e) => setReview(e.target.value)} />

              </div>
              <div className="mb-3">
                <label htmlFor="Review" className="form-label">Email</label>
                <input type="email" className='form-control' placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />

              </div>
              <div className="mb-3">
                <label htmlFor="Review" className="form-label">Name</label>
                <input type="text" className='form-control' placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />

              </div>
              <div className="mb-3">
                <label htmlFor="Review" className="form-label">Profile URL</label>
{/* Show current image */}
{typeof profilePic === "string" && (
  <img
    src={`${ENDPOINT.replace('/api','')}${profilePic}`}
    style={{ width: "60px", height: "60px", marginBottom: "10px" }}
  />
)}

{/* File input */}
<input 
  type="file" 
  className='form-control'
  accept="image/*"
  onChange={(e) => setProfilePic(e.target.files[0])}
/>

              </div>
              <div className="mb-3">
                <label htmlFor="Review" className="form-label">Course Id</label>
                <input type="text" className='form-control' placeholder="Course ID" value={courseId} onChange={(e) => setCourseId(e.target.value)} />

              </div>
              <div className="mb-3">
                <label htmlFor="Review" className="form-label">Status</label>
                <select type="text" className='form-control' placeholder="Status" value={status} onChange={(e) => setStatus(e.target.value)} >
                  <option value="pending">Pending</option>
                  <option value="approved">approved</option>
                  <option value="rejected">Rejected</option>

                </select>

              </div>
              <div className="mb-3">
                <div>
                  <label htmlFor="Review" className="form-label">Status</label>
                </div>

                <Rating
                  name="simple-controlled"
                  value={rating}
                  onChange={(event, newValue) => {
                    setRating(newValue);
                  }}
                />
              </div>
              <div className="mb-3 d-flex justify-content-center " >
                <button className='btn btn-primary w-fit' type="submit">Update Review</button>

              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>



      <tr>
        <td className="col-lg-8">

          <div className="ms-2 flex-grow-1">
            <p>{internship.review}</p>

          </div>
        </td>
        <td>
          <div className="d-flex align-items-center">
            <Avatar className="me-10" src={`${ENDPOINT}${internship.profile_pic}`} sx={{ width: 10, height: 15 }} />
            <div className='ms-2'>
              <h6 className='mb-0 pb-0'>{internship.name + "( " + internship.email + " )"}</h6>
              <Rating className='' name="read-only" value={internship.rating} readOnly size="small" />


            </div>
          </div>
        </td>
        <td>   <div className="ml ms-2">
          <Dropdown className="options-dropdown ml-4">
            <Dropdown.Toggle className="bg-transparent options p-0 w-fit h-fit border-0">
              <MoreVert className="text-dark" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setUpdate(true)}>
                <Edit className="m-1 p-1 w-22" /> Edit Course
              </Dropdown.Item>
              <Dropdown.Item onClick={() => deleteReview(internship.id)}>
                <DeleteForever className="m-1 p-1 w-22" /> Delete Course
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div></td>
      </tr>

    </>
  )
}

export default ReviewItem;